import { ArrowLeft } from "@carbon/icons-react";
import Link from "next/link";
import { useRouter } from "next/router";
import { type FC } from "react";

import { AppTopBarItem } from "@moment/design-system/AppTopBarItem";
import { Icon } from "@moment/design-system/Icon";

import { isDesktopAppMode } from "~/auth/interop/common";
import { CANVAS_NAME, HOMEPAGE_ROUTE } from "~/strings";
import { toTitleCase } from "~/utils/format/string";

import { AppHomeLink } from "../common/AppHomeLink";

export const BackButton: FC = () => {
	const router = useRouter();

	const handleOnClick = async () => {
		await router.push(HOMEPAGE_ROUTE);
	};

	return isDesktopAppMode() ? (
		<AppTopBarItem grow={false}>
			<Link
				href={{ pathname: HOMEPAGE_ROUTE }}
				title={`All ${toTitleCase(CANVAS_NAME.PLURAL)}`}
				className="link--buttonish ml-4 flex items-center gap-2 border-r pr-4 text-sm"
				onClick={handleOnClick}
				shallow
			>
				<Icon icon={ArrowLeft} />
				All {toTitleCase(CANVAS_NAME.PLURAL)}
			</Link>
		</AppTopBarItem>
	) : (
		// Show link to home page in browser mode
		<AppHomeLink />
	);
};
